import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';

import { AuthService } from '../services/auth.service';

@Injectable()
export class InitGuard implements CanActivate {
    constructor(private router: Router,
        private authService: AuthService) { }

    canActivate(next: ActivatedRouteSnapshot) {
        if (this.checkAccount())
            return true;
        else {
            this.router.navigate(['/init']);
            return false;
        }
    }

    checkAccount() {
        if (JSON.parse(localStorage.getItem('account')).id)
            return true;
        else
            return false;
    }
}
